import { api } from "@/utils/apiService";
import React, { useEffect, useState } from "react";
import { getAccessToken } from "../../../utils/authStorage";

export default function AdminAccounts() {
  const token = getAccessToken();
  const [list, setList] = useState([]);
  const [form, setForm] = useState({
    title: "",
    accountEmail: "",
    accountPassword: "",
    price: 0,
    useAutoPricing: false,
  });

  useEffect(() => {
    fetchList();
  }, []);

  async function fetchList() {
    try {
      const res = await api.get("/admin/game-accounts", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) {
        setList(res.data.accounts);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function upload(e) {
    e.preventDefault();
    const fd = new FormData();
    Object.keys(form).forEach((k) => {
      if (form[k] !== undefined) fd.append(k, form[k]);
    });
    // add files
    const files = document.getElementById("images").files;
    for (let i = 0; i < files.length; i++) fd.append("images", files[i]);

    try {
      const res = await api.post("/admin/game-accounts", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.success) {
        alert("Created");
        setForm({});
        fetchList();
      } else alert("Error");
    } catch (error) {
      console.error(error);
      alert("Error");
    }
  }

  return (
    <div style={{ padding: 20 }}>
      <h2>Admin — Game Accounts</h2>
      <form onSubmit={upload}>
        <div>
          Title:{" "}
          <input
            value={form.title || ""}
            onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))}
          />
        </div>
        <div>
          Email:{" "}
          <input
            value={form.accountEmail || ""}
            onChange={(e) =>
              setForm((f) => ({ ...f, accountEmail: e.target.value }))
            }
          />
        </div>
        <div>
          Password:{" "}
          <input
            value={form.accountPassword || ""}
            onChange={(e) =>
              setForm((f) => ({ ...f, accountPassword: e.target.value }))
            }
          />
        </div>
        <div>
          Price (INR):{" "}
          <input
            type="number"
            value={form.price || 0}
            onChange={(e) =>
              setForm((f) => ({ ...f, price: Number(e.target.value) }))
            }
          />
        </div>
        <div>
          Use Auto Pricing:{" "}
          <input
            type="checkbox"
            checked={form.useAutoPricing || false}
            onChange={(e) =>
              setForm((f) => ({ ...f, useAutoPricing: e.target.checked }))
            }
          />
        </div>
        <div>
          Images: <input id="images" type="file" multiple />
        </div>
        <div>
          Description:{" "}
          <textarea
            value={form.description || ""}
            onChange={(e) =>
              setForm((f) => ({ ...f, description: e.target.value }))
            }
          />
        </div>
        <button>Create Account</button>
      </form>

      <h3 style={{ marginTop: 20 }}>Existing</h3>
      {list.map((a) => (
        <div
          key={a._id}
          style={{ border: "1px solid #eee", padding: 8, marginBottom: 8 }}
        >
          <strong>{a.title}</strong> — {a.isSold ? "SOLD" : "Available"} — ₹
          {a.price || a.baseInrCost}
        </div>
      ))}
    </div>
  );
}
